module.exports = __webpack_public_path__ + "5bdff8ce93747e8ac9ab7766aa702cc4.pdf";